import { mainSiteUrl } from '@/mocks/categories';
import { seoContent } from '@/mocks/seoData';

export default function ProblemSolution() {
  return (
    <>
      {/* Problem Section */}
      <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-100">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              {seoContent.problemTitle}
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {seoContent.problemItems.map((item) => (
              <div key={item.title} className="p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/60">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center mb-4">
                  <i className="ri-error-warning-line text-primary-600 text-lg"></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-50">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
            <div className="lg:w-1/2">
              <div className="relative rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20modern%20workspace%20with%20laptop%20displaying%20clean%20organized%20spreadsheet%20with%20product%20thumbnails%20and%20pricing%20columns%2C%20warm%20cream%20and%20soft%20coral%20color%20palette%2C%20minimalist%20desk%20with%20ceramic%20mug%20and%20small%20plant%2C%20soft%20natural%20window%20light%2C%20calm%20productive%20atmosphere%2C%20high%20detail%20editorial%20photography%2C%20professional%20yet%20warm%20and%20inviting%20tone%2C%20gentle%20shadows&width=800&height=600&seq=itaobuy-solution-v3&orientation=landscape"
                  alt="ItaobuySpreadsheet organized product browsing interface"
                  className="w-full h-auto object-cover rounded-2xl"
                  title="ItaobuySpreadsheet - Organized Spreadsheet Shopping Interface"
                />
              </div>
            </div>
            <div className="lg:w-1/2">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">
                {seoContent.solutionTitle}
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                {seoContent.solutionDescription}
              </p>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                {seoContent.solutionCta}
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}